// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__2y_yA","insightsList":"newBusinessInsightsMenu_insightsList__3dg9-","active":"newBusinessInsightsMenu_active__1Y7oF"};